var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8685 7.8263v5.4063c0 2.4494-1.9726 4.4574-4.4274 4.4574H6.8603v2.1405c0 .4413-.2411.8385-.6137 1.0371-.1754.0883-.3507.1324-.526.1324-.2192 0-.4603-.0883-.6576-.2207l-4.5808-3.31C.1753 17.2488 0 16.8957 0 16.5206s.1753-.7282.4822-.9489l4.6027-3.31c.3507-.2427.811-.2868 1.1836-.0882.3726.1986.6137.5958.6137 1.0371v2.1405h4.5808c1.1836 0 2.126-.9489 2.126-2.1405h-.0219V9.4813l2.3014-1.655ZM9.7535.125c.3725-.1986.8328-.1545 1.1835.0882l4.5808 3.31c.3069.2207.4822.5737.4822.9489 0 .3751-.1753.7282-.4822.9488l-4.5808 3.31c-.1973.1545-.4165.2207-.6575.2207-.1754 0-.3507-.0442-.526-.1324-.3727-.1986-.6138-.5958-.6138-1.0371V5.6417H4.5808c-1.1835 0-2.126.9489-2.126 2.1405h.022v3.7071l-2.3015 1.655V7.7601c0-2.4494 1.9726-4.4574 4.4274-4.4574h4.537V1.1622c0-.4413.2411-.8385.6137-1.0371Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default ForwardRef;